import React from 'react'

const Footer = () => {
    return (
        <>
            <footer className="max-w-4xl md:max-w-6xl mx-4 lg:mx-auto pt-10 pb-3 font-circular">
            <div className="flex flex-col md:flex-row items-center justify-center ">
                <p className=' text-center'>
                    Created by Deepjyoti Sarmah
                </p>
                
            </div>
            </footer>
        </>
    )
}

export default Footer;